export function Footer() {
  return (
    <footer className="app-footer">
      <div className="app-footer-title">Madinet Masr</div>
    </footer>
  );
}
